<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <bank-slip-query
        ref="bankSlipRollBack"
        identify="bankSlipRollBack"
        view-source="bankSlipRollBack"
        config-module="1200"
        :is-ar="searchConditions.applicationStatus"
        :oversea="searchConditions.oversea"
        :is-rollback="true"
        :page-mode="0"
        :ar-field="'ar'"
        :total-type="'revenueAbs'"
        grid-config-module="1200003"
      >
        <div slot="operations">
          <!--撤销认领-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRollBack'])" type="primary" no="cancelWriteOff" @click="cancelWriteOffHandler">{{ $t('CargoMsg.Cargo_RevokeClaim') }}</el-button>
          <!--查看明细-->
          <el-button type="primary" no="showDetail" @click="showDetailHandler">{{ $t('CargoMsg.Cargo_ViewDetail') }}</el-button>
          <!--退款-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_returnApply'])" type="primary" no="returnApply" @click="returnApplyHandler">{{ $t('CargoMsg.Cargo_ReturnApply') }}</el-button>
          <!--撤销退款-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_returnApply'])" type="primary" no="returnApplyCancel" @click="returnApplyCancelHandler">{{ $t('CargoMsg.Cargo_ReturnApplyCancel') }}</el-button>
          <!--退款同意-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_returnApplyAudit'])" type="success" no="returnApplyAudit" @click="returnApplyAuditHandler">{{ $t('CargoMsg.Cargo_ReturnApplyAudit') }}</el-button>
          <!--退款拒绝-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_returnApplyAudit'])" type="danger" no="returnApplyReject" @click="returnApplyRejectHandler">{{ $t('CargoMsg.Cargo_ReturnApplyReject') }}</el-button>
          <!--预览凭证-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_previewVoucher'])" type="primary" no="previewVoucher" @click="previewVoucherHandler">{{ $t('CargoMsg.Cargo_PreviewVoucher') }}</el-button>
          <!--导出凭证-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_exportVoucher'])" type="primary" no="exportVoucher" @click="exportVoucherHandler">{{ $t('CargoMsg.Cargo_ExportVoucher') }}</el-button>
        </div>
        <template v-slot:searchAreaHeader>
          <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
            <div class="filters">
              <el-form :inline="true" label-position="left">
                <div class="el-form-item-wrapper dense-radio-group">
                  <el-form-item :label="$t('WriteOff.writeOffType')" class="dense-radio-group">
                    <el-radio-group v-model="searchConditions.oversea">
                      <el-radio :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                      <el-radio :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
                      <el-radio :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" class="dense-radio-group">
                    <el-radio-group v-model="searchConditions.applicationStatus">
                      <el-radio :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                      <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                      <el-radio :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </template>
      </bank-slip-query>
    </div>

    <!-- 查看明细 -->
    <write-off-detail-dialog
      :visible.sync="detailDialog.visible"
      :recheck-button="false"
      :params="detailDialog.params"
    />
    <!-- 退款  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="returnApplyDialog.show"
      :title="$t('CargoMsg.Cargo_ReturnApply')"
      width="340px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="returnApplyDialog.form"
        label-width="120px"
        label-position="right"
      >
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_RemainingClaimedAmount')">
            <el-input-number
              v-model="returnApplyDialog.form.remainingAmount"
              :disabled="true"
              no="amount"
              :precision="2"
              controls-position="right"
              :controls="false"
            />
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_RefundAmount')">
            <el-input-number
              v-model="returnApplyDialog.form.returnApplyAmount"
              no="amount"
              :precision="2"
              :min="0"
              :max="returnApplyDialog.form.remainingAmount"
              controls-position="right"
              :controls="false"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button no="ok" type="primary" @click="doReturnApply">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="returnApplyDialog.show = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <accounting-entry-window
      v-if="accountingEntryWindow.visible"
      :visible="accountingEntryWindow.visible"
      :is-ext="accountingEntryWindow.isExt"
      :prefix-data-provider="accountingEntryWindow.prefixDataProvider"
      :account-title-data-provider="accountingEntryWindow.accountTitleDataProvider"
      :mapping-departments="accountingEntryWindow.mappingDepartments"
      :mapping-staffs="accountingEntryWindow.mappingStaffs"
      :voucher="accountingEntryWindow.rowData"
      :index="accountingEntryWindow.index"
      :account-set="accountingEntryWindow.accountSet"
      :check="false"
      :check-department="false"
      :preview="true"
      @close="() => accountingEntryWindow.visible=false"
      @updateAudit="$refs.bankSlipRollBack.refreshPageHandler()"
    />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { DocumentManage } from '@/utils/commonUtil'
import BankSlipQuery from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipQuery'
import writeOffDetailDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDetailDialog'
import { ACT_AMOUNT_APPROVE_NONE, BANK_SLIP_RETURN_APPLY_STATE_PENDING, BANK_SLIP_RETURN_APPLY_STATE_REFUNDED, BANK_SLIP_RETURN_APPLY_STATE_REJECTED, BANK_SLIP_RETURN_APPLY_STATE_CANCELED, RECEIVE_TYPE_REFUND } from '@/class/cargo/model/parameters/ClearingConstants'
import * as writeoffApi from '@/api/act/writeoff'
import { getLoading } from '@/utils/utilBaseElement'
import { LOG_CLAIM_BANK_RECEIPT } from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import { returnApply, updateReturnApply } from '@/api/clearing/actualAmount'
import AccountingEntryWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/AccountingEntryWindow'
import { queryActualAmountAccountingDocument2 } from '@/api/financeManage/accountingDocument'
import VoucherUtils from '@/utils/VoucherUtils'

export default {
  name: 'BankSlipRollBack',
  components: {
    BankSlipQuery,
    writeOffDetailDialog,
    searchItem,
    AccountingEntryWindow
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      documentManage: new DocumentManage(),
      searchConditions: {
        oversea: -1,
        applicationStatus: -1
      },
      detailDialog: {
        visible: false,
        recheckButton: false,
        params: {}
      },
      gridApi: null,
      location: LOG_CLAIM_BANK_RECEIPT.code,
      returnApplyDialog: {
        show: false,
        form: {
          remainingAmount: 0, // 剩余金额
          returnApplyAmount: 0 // 退款金额
        }
      },
      // 预览凭证
      accountingEntryWindow: {
        visible: false,
        index: -1,
        accountSet: null,
        rowData: [],
        prefixDataProvider: [],
        accountTitleDataProvider: [],
        mappingDepartments: [],
        mappingStaffs: [],
        isExt: false
      }
    }
  },
  computed: {},
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    showDetailHandler() {
      const actualAmount = this.$refs.bankSlipRollBack.selectedData
      if (actualAmount == null || !actualAmount.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectAWaterBillRecord'))
        return
      }
      const params = {}
      params.actualAmount = actualAmount
      const selections = []
      selections.push(actualAmount)
      params.queryActualAmountSelections = selections
      params.hasApprove = true
      params.view = this
      this.detailDialog.params = params
      this.detailDialog.visible = true
    },
    cancelWriteOffHandler() {
      const actualAmount = this.$refs.bankSlipRollBack.selectedData
      if (actualAmount === null || !actualAmount.uuid) {
        this.$message.warning(this.$t('Clearing.PleaseAWaterBillRecord'))
      } else if (actualAmount.type === RECEIVE_TYPE_REFUND.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WaterRefundedNoCancel'))
        return
      } else if (this.$store.getters.userId !== actualAmount.verificationBy) {
        this.$message.warning(this.$t('Clearing.OnlyCanRevokeTheBill'))
      } else if (actualAmount.reconciliation) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PRSCSCRICP'))
      } else if (actualAmount.approvedState !== ACT_AMOUNT_APPROVE_NONE.code) {
        this.$message.warning(this.$t('Clearing.WaterCannotBeRevokedFirst'))
      } else {
        this.loading = getLoading()
        // 水单认领-撤销认领后自动删除凭证
        if (Number(cache.config.get('AutomaticallyGenerateVouchers')) === 1) {
          const actualAmount = this.$refs.bankSlipRollBack.selectedData
          writeoffApi.rollbackChargeWriteoff({ actualAmountUuid: actualAmount.uuid, location: this.location, autoGenerateVoucher: true, branchId: actualAmount.branchId }).then(res => {
            this.$refs.bankSlipRollBack.refreshPageHandler()
            this.$message.success(this.$t('Clearing.WaterBillRevocationSuccessful'))
          }).catch((err) => {
            console.log('err', err)
            this.loading.close()
          })
          return
        }
        writeoffApi.checkExportedToVoucher({ actualAmountUuid: actualAmount.uuid }).then(resp => {
          this.checkExportedToVoucherResultHandler(resp)
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        })
      }
    },
    async checkExportedToVoucherResultHandler(event) {
      const exist = event.data
      if (exist) {
        this.$message.warning(this.$t('Clearing.ThisPleaseDeleteTheAgain'))
        this.loading.close()
        return
      }
      const actualAmount = this.$refs.bankSlipRollBack.selectedData
      await writeoffApi.rollbackChargeWriteoff({ actualAmountUuid: actualAmount.uuid, location: this.location, branchId: actualAmount.branchId }).then(res => {
        this.$refs.bankSlipRollBack.refreshPageHandler()
        this.$message.success(this.$t('Clearing.WaterBillRevocationSuccessful'))
      }).catch((err) => {
        console.log('err', err)
        this.loading.close()
      })
    },
    // 退款
    returnApplyHandler() {
      this.selectedData = this.$refs.bankSlipRollBack.selectedData
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('Clearing.WaterBillNotSelected'))
        return
      }
      // 审批中
      if (this.selectedData.returnApplyState === BANK_SLIP_RETURN_APPLY_STATE_PENDING.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReturnApplyCheck'))
        return
      }
      // 剩余金额
      this.returnApplyDialog.form.remainingAmount = NumberUtils.ToFixed2(this.selectedData.remainAmount - this.selectedData.returnAmount, 2)
      if (this.returnApplyDialog.form.remainingAmount === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemainingClaimedAmountZero'))
        return
      }
      // 退款金额
      this.returnApplyDialog.form.returnApplyAmount = this.returnApplyDialog.form.remainingAmount
      this.returnApplyDialog.show = true
    },
    doReturnApply() {
      if (this.returnApplyDialog.form.returnApplyAmount === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReturnApplyAmountZero'))
        return
      }
      this.loading = getLoading()
      returnApply({ uuid: this.selectedData.uuid, returnApplyAmount: this.returnApplyDialog.form.returnApplyAmount, version: this.selectedData.version }).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
          this.$refs.bankSlipRollBack.refreshPageHandler()
        }
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.returnApplyDialog.show = false
        this.loading.close()
      })
    },
    // 撤销退款
    returnApplyCancelHandler() {
      this.doUpdateReturnApply(BANK_SLIP_RETURN_APPLY_STATE_CANCELED.code)
    },
    // 退款同意
    returnApplyAuditHandler() {
      this.doUpdateReturnApply(BANK_SLIP_RETURN_APPLY_STATE_REFUNDED.code)
    },
    // 退款拒绝
    returnApplyRejectHandler() {
      this.doUpdateReturnApply(BANK_SLIP_RETURN_APPLY_STATE_REJECTED.code)
    },
    doUpdateReturnApply(returnApplyState) {
      const rows = this.$refs.bankSlipRollBack.selectedDataList
      if (rows.length === 0) {
        this.$message.warning(this.$t('Clearing.WaterBillNotSelected'))
        return
      }
      const returnApplys = []
      for (const row of rows) {
        if (row.returnApplyState !== BANK_SLIP_RETURN_APPLY_STATE_PENDING.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ReturnApplyAuditCheck'))
          return
        }
        returnApplys.push({ uuid: row.uuid, returnApplyState: returnApplyState, version: row.version })
      }
      if (returnApplys.length === 0) {
        return
      }
      this.loading = getLoading()
      updateReturnApply(returnApplys).then(res => {
        if (res.data) {
          if (returnApplyState === BANK_SLIP_RETURN_APPLY_STATE_CANCELED.code) {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          }
          this.$refs.bankSlipRollBack.refreshPageHandler()
        }
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    previewVoucherHandler() {
      const rows = this.$refs.bankSlipRollBack.selectedDataList
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const actualAmountUuids = []
      for (const item of rows) {
        actualAmountUuids.push(item.uuid)
      }
      if (actualAmountUuids.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      this.loading = getLoading()
      queryActualAmountAccountingDocument2(actualAmountUuids).then(res => {
        const voucherList = res.data.voucherList || []
        const accountSetList = res.data.accountSetList || []
        if (voucherList && voucherList.length > 0) {
          this.accountingEntryWindow.isExt = Number(cache.config.get('ext')) === 1
          this.accountingEntryWindow.visible = true
          this.accountingEntryWindow.multiAccountSet = true
          this.accountingEntryWindow.rowData = voucherList
          this.accountingEntryWindow.accountSet = accountSetList.length > 0 ? accountSetList[0] : null
          this.accountingEntryWindow.index = 0
          if (this.accountingEntryWindow.accountSet) {
            const prefixList = []
            for (const accountingDocumentType of this.accountingEntryWindow.accountSet.accountingDocumentType) {
              if (prefixList.length === 0) {
                prefixList.push(accountingDocumentType)
              } else {
                let bExist = false
                for (const prefixData of prefixList) {
                  if (prefixData.prefix === accountingDocumentType.prefix) {
                    bExist = true
                    break
                  }
                }
                if (!bExist) prefixList.push(accountingDocumentType)
              }
            }
            this.accountingEntryWindow.prefixDataProvider = prefixList
            this.accountingEntryWindow.accountTitleDataProvider = this.accountingEntryWindow.accountSet.accountTitle || []
            this.accountingEntryWindow.mappingDepartments = this.accountingEntryWindow.accountSet.mappingDepartments || []
            this.accountingEntryWindow.mappingStaffs = this.accountingEntryWindow.accountSet.mappingStaffs || []
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_BankSlipNotVoucher'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    exportVoucherHandler() {
      const rows = this.$refs.bankSlipRollBack.selectedDataList
      VoucherUtils.exportVoucherHandler(this, rows, 'bankSlipRollBack')
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
